window.initCartRecommendationSlider = function () {

    const slider = document.querySelector('.cart-recommendations-swiper');

    if (!slider) return;

    if (slider.swiper) {
        slider.swiper.destroy(true, true);
    }

    new Swiper(slider, {
        slidesPerView: 2,
        spaceBetween: 10,
        loop: false,
        speed: 800,
        // autoplay: {
        //     delay: 4000,
        //     disableOnInteraction: false,
        //     pauseOnMouseEnter: true
        // },
        breakpoints: {
            0: {
                slidesPerView: 2,
                spaceBetween: 10
            },
            750: {
                slidesPerView: 2,
                spaceBetween: 10
            }
        }
    });

};

document.addEventListener("DOMContentLoaded", () => {
    window.initCartRecommendationSlider();
});